import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed, watch } from 'vue'
import PasswordRule from '@/components/account/PasswordRule.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordValidator',
  props: {
    password: null,
    confirmation: null
  },
  emits: ['passwordStrengthChanged'],
  setup(__props: any, { emit }) {

const props = __props as { password:string|null, confirmation?:string|null };




const contains = computed(() => {
  const hasLowercase = /[a-z]/
  const hasUppercase = /[A-Z]/
  const hasNumber = /\d/
  const hasSpecialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/

  return {
    lowercase: props.password ? hasLowercase.test(props.password) : false,
    uppercase: props.password ? hasUppercase.test(props.password) : false,
    number: props.password ? hasNumber.test(props.password) : false,
    specialChar: props.password ? hasSpecialChars.test(props.password) : false,
    eightChars: props.password ? props.password.length >= 8 : false
  }
})

const passwordStrongEnough = computed(() => {
  return contains.value.lowercase && contains.value.uppercase && contains.value.number && contains.value.specialChar && contains.value.eightChars && (props.confirmation ? props.password === props.confirmation : true)
})

watch(passwordStrongEnough, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    emit('passwordStrengthChanged', newValue)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    class: "no-mb",
    style: {"margin-top":"16px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(PasswordRule, {
            label: "Bevat minimaal 8 tekens.",
            valid: _unref(contains).eightChars
          }, null, 8, ["valid"]),
          _createVNode(PasswordRule, {
            label: "Bevat een kleine letter.",
            valid: _unref(contains).lowercase
          }, null, 8, ["valid"]),
          _createVNode(PasswordRule, {
            label: "Bevat een hoofdletter.",
            valid: _unref(contains).uppercase
          }, null, 8, ["valid"]),
          _createVNode(PasswordRule, {
            label: "Bevat een nummer.",
            valid: _unref(contains).number
          }, null, 8, ["valid"]),
          _createVNode(PasswordRule, {
            label: "Bevat een speciaal teken. Bijv. (!@#$%&*)",
            valid: _unref(contains).specialChar
          }, null, 8, ["valid"]),
          (props.confirmation && props.confirmation.length)
            ? (_openBlock(), _createBlock(PasswordRule, {
                key: 0,
                label: "Wachtwoord en bevestiging komen overeen.",
                valid: props.password === props.confirmation
              }, null, 8, ["valid"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})